import { ImageKeyUploadField } from "@/shared/ui/ImageKeyUploadField";

export const PRODUCT_IMAGE_KEY_PREFIX = "uploads/products";

export type ProductImageUploadFieldProps = {
  /** ค่า key ปัจจุบัน (จาก object store) */
  value: string;
  onChange: (key: string) => void;
  /** ไฟล์ที่เลือกไว้ รออัปโหลดตอนกด submit */
  pendingFile: File | null;
  onFileSelect: (file: File | null) => void;
  disabled?: boolean;
  label?: string;
};

/**
 * ฟิลด์อัปโหลดรูปสินค้า: ไม่อัปโหลดตอนเลือกไฟล์ จะอัปโหลดเมื่อกด submit
 * Parent ต้องเก็บ pendingFile ใน state และตอน submit เรียก uploadImageToKey(pendingFile) แล้วได้ key ไปบันทึก
 */
export function ProductImageUploadField({
  value,
  onChange,
  pendingFile,
  onFileSelect,
  disabled,
  label = "ຮູບສິນຄ້າ",
}: ProductImageUploadFieldProps) {
  return (
    <ImageKeyUploadField
      value={value}
      onChange={onChange}
      keyPrefix={PRODUCT_IMAGE_KEY_PREFIX}
      label={label}
      deferUpload
      pendingFile={pendingFile}
      onFileSelect={(file) => onFileSelect(file ?? null)}
      onClear={() => {
        onFileSelect(null);
        onChange("");
      }}
      disabled={disabled}
      aspectRatio="aspect-square"
      className="w-full"
    />
  );
}
